import { AgGridReact } from 'ag-grid-react';
import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { useAdminCommonStore } from 'src/hooks/admin/adminCommon';
import { useUserStore } from 'src/hooks/admin/user';
import useReduxState from 'src/hooks/useReduxState';
import { __remove, __set } from 'src/store/axios_indicator';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/support/Helper';
import NoResultContent from '../../HomePageContent/NoResultContent';
import { Tooltip } from 'src/component/Tooltip';
import { useAdminAccountFilterStore } from 'src/hooks/admin/adminAccountFilter';


var roleData = [];
const speedboatMapping = {
  S: "Silica",
  T: "Abacus",
  B: "EBV",
  Abacus: "T",
  ABACUS: "T",
  Silica: "S",
  SILICA: "S",
  EBV: "B",
}
const UserSearchAcctList = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ searchSponsorAccounts, searchSponsorAccountsMessage }, {
    get_search_sponsor_accounts_list
  }, { set_search_sponsor_accounts_list }] = useUserStore();
  const [{ roleList, roleListMessage }, { get_role_list }, { }] = useAdminCommonStore();
  const [rowData, setRowData] = useState([]);
  const [{ userSearchAcctPopupStatus, selectedRoles, selectedAccounts }, { }, {
    set_role_selection_popup_status, set_select_user_sponsor_accounts, set_selected_accounts
  }] = useUserStore();
  const [{ filter_list }] = useAdminAccountFilterStore();
  const [disableSearch] = useReduxState(true, 'setDisableAccountSearch');
  const gridRef = React.useRef();
  const userData = props.userData;
  const [selectedIndex, setIndex] = useState(-1);
  const [{ userAcctList }] = useUserStore();
  const [isSponsorRoleSelect, setIsSponsorRoleSelect] = useReduxState(false, 'setIsSponsorRoleSelect');

  useEffect(() => {
    roleData = roleList;
  }, [roleList])

  const addRole = (e) => {
    const role = e.data.Role;
    let renderedRole = Helper.renderRoles(role, roleData);
    const cellContent = e.data.selected ? <a className={'text-blue2'} onClick={() => {
      openPopup(e.data, e.rowIndex)
    }}><u>
        {role.length > 0 ? renderedRole : 'Select Role (required)'}
      </u>
    </a> : <span className={'text-black-stone'}>{role.length > 0 ? renderedRole : 'Select Role (required)'}</span>

    return role.length > 0 ? <Tooltip
      arrow={false}
      position={'top left'}
      opener={() => cellContent}
      content={() => `${renderedRole}`}
    /> : cellContent;
  }
  const roleSortingAgGrid = (roleA, roleB) => {
    let renderedRoleA = Helper.renderRoles(roleA, roleData);
    let renderedRoleB = Helper.renderRoles(roleB, roleData);
    return renderedRoleA.localeCompare(renderedRoleB);
  }
  useEffect(() => {
    if (selectedIndex < 0) {
      return;
    }
    const role = selectedRoles.map((role) => {
      return role.roleName;
    }).join(', ');
    let accList = [...searchSponsorAccounts];
    accList = accList.map(item => {
      if (item['key'] === selectedIndex) {
        return {
          ...item,
          ['rolename']: role
        };
      }
      return item;
    });

    set_search_sponsor_accounts_list(accList);
    setIndex(-1)
  }, [selectedRoles]);

  const openPopup = (account, rowIndex) => {
    setIsSponsorRoleSelect(true);
    setIndex(account?.key)
    set_select_user_sponsor_accounts({ account, userData, })
    set_role_selection_popup_status(true);
  };
  const [columnDefs] = useState([
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      width: 50,
      tooltipValueGetter: (params) => {
        return params.node.selectable ? null : "This account is already sponsored"
      }
    },
    { field: 'AccountNumber', },
    { field: 'AccountName', },
    { field: 'Role', cellRenderer: addRole, sortable: true, width: 231, comparator: roleSortingAgGrid },
    {
      field: 'Speedboat', cellRenderer: (e) => {
        return Helper.speedboatMappings[e.data.Speedboat];
      }
    },
    { field: 'SalesOrg', },
  ]);

  useEffect(() => {
    if (!userSearchAcctPopupStatus) {
      setRowData([]);
    }
  }, [userSearchAcctPopupStatus])

  const onSelectionChanged = (event) => {
    set_selected_accounts(event.api.getSelectedRows());
  }
  useEffect(() => {
    gridRef?.current?.api?.forEachNode((node) => {
      const acc = selectedAccounts.find((a) => {
        return a.key === node.data.key;
      })
      node?.setData({
        ...node?.data,
        Role: node?.data?.Role,
        selected: !!acc
      })
      acc && node?.setSelected(true);
    });
  },)

  const defaultColDef = React.useMemo(() => {
    return {
      sortable: true,
      filter: true,
      enableRowGroup: false,
      enableValue: true,
      suppressMovable: true,
      resizable: true
      // maxWidth: 250
    };
  }, []);
  useEffect(() => {
    get_role_list()
  }, []);

  useEffect(() => {
    async function fetchHere() {
      await fetchAPICall()
    }

    fetchHere();
  }, [filter_list,]);

  useEffect(() => {
    let _acctList = [];
    if (searchSponsorAccounts?.length > 0) {
      searchSponsorAccounts.map((_user, idx) => {
        let _data = {
          AccountNumber: _user.accountNumber,
          AccountName: _user.accountName,
          Role: _user.rolename ? _user.rolename.split(',').map(v => v.trim()) : [],
          Speedboat: _user.speedBoat,
          SalesOrg: _user.salesOrg,
          key: idx,
          selected: false
        }
        _acctList.push(_data);
      })
    }
    setRowData(_acctList)
  }, [searchSponsorAccounts]);

  const fetchAPICall = async () => {
    if (disableSearch) {
      return;
    }
    set_selected_accounts([]);
    __set('USER_API_CALL')
    if (!Helper.checkObjectHaveValue(filter_list)) {
      const params = {
        UserId: userData.id,
        accountNumber: filter_list.accountNumber?.searchKeyword?.trim?.() || '',
        accountName: filter_list.accountName?.searchKeyword?.trim?.() || '',
        speedBoat: filter_list.speedboat?.searchKeywordArr?.map((v) => {
          return v.value
        }) || [],
        salesOrg: filter_list.salesOrg?.searchKeywordArr?.map((v) => v.value) || [],
      }
      await get_search_sponsor_accounts_list(params)
    } else {
      set_search_sponsor_accounts_list([]);
    }
    __remove('USER_API_CALL')
  };

  const isRowSelectable = useMemo(() => {
    return (params) => {
      const found = userAcctList.find((acc) => {
        const accSB = speedboatMapping[acc.speedboat]
        return acc.accountNumber === params.data.AccountNumber && acc.salesOrg === params.data.SalesOrg && accSB === params.data.Speedboat;
      })
      return !found;
    };
  }, []);
  const onColumnResided = (event) => {
    event.columnApi.getColumn('0').setActualWidth(50);
  }
  const onGridReady = (params) => {
    params.api.addEventListener('columnResized', onColumnResided);
    params.api.sizeColumnsToFit(); 
  }

  return (
    <>
      {__check(['USER_API_CALL']).render}
      {!__check(['USER_API_CALL']).status &&
        <>
          {(rowData?.length > 0 && roleList?.length > 0) ?
            <div className='adminconsole-container'>
              <div className="ag-theme-alpine ag-grd-hg mb-5">
                <AgGridReact
                  ref={gridRef}
                  rowData={rowData}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowSelection={'multiple'}
                  suppressRowClickSelection={true}
                  isRowSelectable={isRowSelectable}
                  onSelectionChanged={onSelectionChanged}
                  debounceVerticalScrollbar={true}
                  onGridReady={onGridReady}
                >
                </AgGridReact>
              </div>
            </div> :
            <>
              {!Helper.checkObjectHaveValue(filter_list) &&
                <div className='container mt-5 w-auto'>
                  <NoResultContent message={searchSponsorAccountsMessage || roleListMessage || "Sorry! We can't find any results based on your selection."}
                    type={(searchSponsorAccountsMessage || roleListMessage) ? 'danger' : 'info'}
                    isDisplay={false} />
                </div>
              }
            </>
          }
        </>}
    </>
  )
}

export default UserSearchAcctList;
